import React from 'react'
import { connect } from 'react-redux'
import { closeModal, openModal } from '../../../../action/positioned-modal-state'
import messages from './messages.json'
import './index.scss'

const UpgradeModal = props => {
  const { closeModal, positionedModal, openModal } = props,
    { message } = positionedModal.data.upgrade,
    makeCopy = () => {
      const strs = messages[message] ? messages[message] : []
      return strs.map((str, idx) => {
        return (<p style={{ marginTop: '10px' }} key={`upgrade-str-${idx}`}>{str}</p>)
      })
    }
  return (
    <div className='upgrade-container'>
      <div className='upgrade-modal center' onClick={(e) => e.stopPropagation()}>
        <div className='upgrade-icon horizontal-center'></div>
        <div style={{ textAlign: 'center' }}>
          {makeCopy()}
        </div>
        <div style={{ marginTop: '10px', display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <button style={{ margin: '0px', width: '45%', backgroundColor: 'gray' }}
            onClick={closeModal} >CANCEL</button>
          <button style={{ margin: '0px', width: '45%' }} onClick={() => { openModal({ subInfo: true }) }}>UPGRADE</button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  positionedModal: state.positionedModal
})

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal()),
  openModal: data => dispatch(openModal(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeModal)
